import { createContext, useContext } from 'react';

type ModalContextValue = {
    onHide: () => void;
    closeButton?: boolean;
};

export const ModalContext = createContext<ModalContextValue | null>(null);

export const useModalContext = () => {
    const context = useContext(ModalContext);

    if (!context) {
        throw new Error('Modal components must be used inside <Modal>');
    }

    return context;
};
